import {defineTokens} from '@chakra-ui/react3'

export const cursor = defineTokens.cursor({
    auto: {value: 'auto'},
    default: {value: 'default'},
    pointer: {value: 'pointer'},
    wait: {value: 'wait'},
    text: {value: 'text'},
    move: {value: 'move'},
    help: {value: 'help'},
    notAllowed: {value: 'not-allowed'},
    none: {value: 'none'},
    contextMenu: {value: 'context-menu'},
    progress: {value: 'progress'},
    cell: {value: 'cell'},
    crosshair: {value: 'crosshair'},
    verticalText: {value: 'vertical-text'},
    alias: {value: 'alias'},
    copy: {value: 'copy'},
    noDrop: {value: 'no-drop'},
    grab: {value: 'grab'},
    grabbing: {value: 'grabbing'},
    allScroll: {value: 'all-scroll'},
    colResize: {value: 'col-resize'},
    rowResize: {value: 'row-resize'},
    nResize: {value: 'n-resize'},
    eResize: {value: 'e-resize'},
    sResize: {value: 's-resize'},
    wResize: {value: 'w-resize'},
    neResize: {value: 'ne-resize'},
    nwResize: {value: 'nw-resize'},
    seResize: {value: 'se-resize'},
    swResize: {value: 'sw-resize'},
    ewResize: {value: 'ew-resize'},
    nsResize: {value: 'ns-resize'},
    neswResize: {value: 'nesw-resize'},
    nwseResize: {value: 'nwse-resize'},
    zoomIn: {value: 'zoom-in'},
    zoomOut: {value: 'zoom-out'}
})
